import React, { useState } from 'react';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import toast from 'react-hot-toast';

interface ExportButtonsProps {
  onExportPdf: () => Promise<void>;
  onExportExcel: () => Promise<void>;
  label?: string;
}

const ExportButtons: React.FC<ExportButtonsProps> = ({ onExportPdf, onExportExcel, label = 'Exportar' }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState<string | null>(null);

  const handleExport = async (type: 'pdf' | 'excel', fn: () => Promise<void>) => {
    setLoading(type);
    try {
      await fn();
      toast.success(`${type.toUpperCase()} exportado com sucesso!`);
    } catch {
      toast.error(`Erro ao exportar ${type.toUpperCase()}`);
    } finally {
      setLoading(null);
      setOpen(false);
    }
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 text-sm font-medium text-gray-700 transition-colors">
        <Download className="h-4 w-4" /> {label}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border z-50">
            <button onClick={() => handleExport('pdf', onExportPdf)} disabled={loading === 'pdf'}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 transition-colors rounded-t-lg">
              <FileText className="h-4 w-4 text-red-500" />
              {loading === 'pdf' ? 'Gerando...' : 'Exportar PDF'}
            </button>
            <button onClick={() => handleExport('excel', onExportExcel)} disabled={loading === 'excel'}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors rounded-b-lg border-t">
              <FileSpreadsheet className="h-4 w-4 text-green-500" />
              {loading === 'excel' ? 'Gerando...' : 'Exportar Excel'}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ExportButtons;
